import React, {useEffect, useState} from 'react';
import {Box, Button} from '@material-ui/core';
import {NavigationService} from 'services/index';
import {reduxToggleSidePanel} from 'appredux/actions';
import CheckIcon from 'components/CheckIcon/CheckIcon';
import {Route} from 'react-router-dom';
import {
  IGenericResponse,
  ISupplierUserPermission,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {PermissionsService} from 'services/PermissionsService';
import {ESupplierUserPermissions} from 'constants/index';
import {
  apiGetSupplierPermissions,
  apiUpdateSupplierPermissions,
} from 'constants/Api';
import {UserPermissionsForm} from 'components/UserForm/UserPermissionsForm';
import {Skeleton} from '@material-ui/lab';

export default function EditTeamMemberPermissions(props: {
  loggedInUser: ISupplierUserProfile;
  userId: string | number;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
  const [supplierPermissions, setSupplierPermissions] = useState<
    ISupplierUserPermission[]
  >([]);
  const [hasSuccessfullyUpdated, setHasSuccessfullyUpdated] = useState(false);

  // fetch supplier permissions
  useEffect(() => {
    setIsLoadingPermissions(true);
    apiGetSupplierPermissions(props.userId)
      .then((supplierPermissions) =>
        setSupplierPermissions(supplierPermissions),
      )
      .catch((err) => {
        alert(
          'Failed to fetch permissions at the moment. Please try again later',
        );
        console.error('Failed to fetch permissions', err);
      })
      .finally(() => setIsLoadingPermissions(false));
  }, [props.userId]);

  const handleSubmit = (permissionIds: number[]) => {
    if (!canWrite) return;
    setIsLoading(true);

    apiUpdateSupplierPermissions(props.userId, permissionIds)
      .then((data: IGenericResponse) => {
        if (data.success) setHasSuccessfullyUpdated(true);
        else alert(data.message);
      })
      .then(() => {
        if (props.loggedInUser.userId == props.userId)
          setTimeout(() => window.location.reload(), 2000);
      })
      .catch((err) => {
        alert(
          'Failed to update permissions at the moment. Please try again later',
        );
        console.error('Failed to update permissions', err);
      })
      .finally(() => setIsLoading(false));
  };

  const teamLink = props.loggedInUser.isAdmin ? '/company/team' : '/team';

  const permissions = new PermissionsService(props.loggedInUser);
  const canWrite = permissions.hasPermission(
    ESupplierUserPermissions.TEAM_WRITE,
  );

  if (hasSuccessfullyUpdated) {
    return (
      <Route
        render={() => (
          <div className="side-panel-success-container">
            <div className="mid-section">
              <div className="success-gif">
                <CheckIcon />
              </div>
              <div className="success-msg">
                Team member updated successfully
              </div>
            </div>
            <div className="btn-container">
              <Button
                className="primary-btn"
                type="submit"
                variant="outlined"
                color="primary"
                disabled={isLoading}
                onClick={() => {
                  reduxToggleSidePanel(false, null);
                  NavigationService.navigate('/');
                  setTimeout(() => NavigationService.navigate(teamLink), 50);
                }}
              >
                View Team
              </Button>
            </div>
          </div>
        )}
      />
    );
  }

  if (isLoadingPermissions) {
    return (
      <Box padding={4}>
        <Box marginBottom={3}>
          <Skeleton height={40} variant={'rect'} />
        </Box>
        <Box>
          <Skeleton height={400} variant={'rect'} />
        </Box>
      </Box>
    );
  }

  return (
    <UserPermissionsForm
      loggedInUser={props.loggedInUser}
      supplierPermissions={supplierPermissions}
      isLoading={isLoading}
      submitButtonTitle={'Update'}
      onSubmit={handleSubmit}
      cancelButtonTitle={'Cancel'}
      onCancel={() => reduxToggleSidePanel(false)}
      readonly={!canWrite}
    />
  );
}
